import store from '../store'

export const placeSearcherMixin = {
  data() {
    return {
      showResultSearchPlace: false,
      centerSetPlace: {},
      isFilteringToggle: false,
      infoPlaceContent: {}
    }
  },
  methods: {
    placeToMap(item) {
      this.infoWinPlaceOpen = false
      this.showResultSearchPlace = false

      store.dispatch('setIsFiltering', true)
      this.isFilteringToggle = true
      this.infoPlaceContent = {
        name: item.name,
        formattedAddress: item.formatted_address
      }

      this.$nextTick(() => {
        this.mapRef.setZoom(15)
        this.centerSetPlace = item.geometry.location
        this.showResultSearchPlace = true
        this.mapRef.setCenter(item.geometry.location)
        this.infoWindowPlacePos = {
          lat: item.geometry.location.lat(),
          lng: item.geometry.location.lng()
        }
        setTimeout(() => {
          if (this.isFilteringToggle) {
            store.dispatch('setIsFiltering', false)
            this.isFilteringToggle = false
          }
          this.infoWinPlaceOpen = true
        }, 1000)
      })
    },
    initSearchPlace() {
      store.dispatch('setIsFiltering', true)
      this.isFilteringToggle = true

      this.infoWinPlaceOpen = false
      this.infoPlaceContent = {}
      this.infoWindowPlacePos = null
      const bounds = new google.maps.LatLngBounds()
      bounds.extend({lat: 6.254790211409118, lng: -75.551029793457})
      this.mapRef.fitBounds(bounds)
      this.mapRef.setZoom(13)
      this.showResultSearchPlace = false
      setTimeout(() => {
        if (this.isFilteringToggle) {
          store.dispatch('setIsFiltering', false)
          this.isFilteringToggle = false
        }
      }, 1000)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/placeSearcherMixin.js